module.exports = __webpack_public_path__ + "static/media/Miraji.a821461a.jpg";